import React from "react";

export type FilterStatus = "ALL" | "PENDING" | "CONFIRMED";

const STATUS_CONFIG: Record<
  FilterStatus,
  {
    label: string;
    bgColor: string;
    selectedBgColor: string;
    textColor: string;
    selectedClassName: string;
  }
> = {
  ALL: {
    label: "전체 주문",
    bgColor: "bg-gray-50 border border-gray-200",
    selectedBgColor: "bg-white",
    textColor: "text-gray-400",
    selectedClassName:
      "shadow-md ring ring-offset-1 ring-primary/80 border text-gray-900",
  },
  PENDING: {
    label: "확인 필요 주문",
    bgColor: "bg-blue-300",
    selectedBgColor: "bg-blue-600 brightness-110",
    textColor: "text-white",
    selectedClassName: "shadow-md ring ring-offset-1 ring-primary/80",
  },
  CONFIRMED: {
    label: "확정 주문",
    bgColor: "bg-green-300",
    selectedBgColor: "bg-green-500 brightness-110",
    textColor: "text-white",
    selectedClassName: "shadow-md ring ring-offset-1 ring-primary/80",
  },
};

interface FilterStatusChipProps {
  status: FilterStatus;
  isSelected: boolean;
  onClick: () => void;
}

const FilterStatusChip: React.FC<FilterStatusChipProps> = ({
  status,
  isSelected,
  onClick,
}) => {
  const { label, bgColor, selectedBgColor, textColor, selectedClassName } =
    STATUS_CONFIG[status];

  const finalBgColor = isSelected ? selectedBgColor : bgColor;

  const finalSelectedClassName = isSelected
    ? selectedClassName
    : "hover:opacity-80";

  return (
    <button
      onClick={onClick}
      className={`px-3 py-1.5 rounded-full font-medium transition-all duration-200 whitespace-nowrap ${finalBgColor} ${textColor} ${finalSelectedClassName}`}
    >
      {label}
    </button>
  );
};

export default FilterStatusChip;
